import React from 'react';
import TextField from '@material-ui/core/TextField';
import StatesService from '../../../Service/StatesService';
import Loader from '../../../Component/Common/Loader';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MUIDataTable from 'mui-datatables';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';
import { green, orange } from '@material-ui/core/colors';
import PageHeader from '../../Common/PageHeader';
import { Link } from 'react-router-dom';
import { toastError, toastOnDeleteRecordConfirm } from '../../../SweetAlertUtil/util';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { hot } from 'react-hot-loader';

export default hot(module)(
	class Index extends React.Component {
		constructor(props) {
			super(props);
			this.state = {
				recommendedMaxRate: '',
				recommendedRate: '',
				shortTerm: '',
				touched: {
					recommendedMaxRate: false,
					recommendedRate: false,
					shortTerm: false,
					valMoreThanHundred: false,
					valLessThanZero: false
				},
				error: {
					recommendedMaxRate: false,
					recommendedRate: false,
					shortTerm: false,
					valMoreThanHundred: false,
					valLessThanZero: false,
					validForm: false
				},
				_isLoading: false,
				_setLoader: false,
				tableData: [],
				selectedRow: null
			};
		}

		getAllStateByTenant = async () => {
			this.setState({ _setLoader: true });
			let data = await StatesService.getAllStateByTenant(this.props.match.params.id);
			if (data && data.length > 0) {
				this.setState({ tableData: data, _setLoader: false });
			} else {
				toastError(data.data);
				this.setState({ _setLoader: false });
			}
		};

		setLoader(value) {
			this.setState({ _isLoading: value });
		}

		getMuiTheme = () =>
			createMuiTheme({
				overrides: {
					MUIDataTableHeadCell: {
						root: {
							fontSize: '15px',
							fontWeight: 'bold',
							textAlign: 'center'
						},
						toolButton: {
							marginLeft: '10%',
							margin: '0 auto'
						},
						sortAction: {
							margin: '0 auto'
						}
					},
					MUIDataTableBodyCell: {
						root: {
							textAlign: 'center'
						}
					}
				}
			});

		updateRecommendedMaxRate(value, min, recommended) {
			const floatValue = parseFloat(value);
			const floatMin = parseFloat(min);

			this.setState(() => {
				this.state.touched.recommendedMaxRate = true;
				this.state.touched.valMoreThanHundred = true;
				this.state.error.validForm = false;
			});

			if (value.length == 0) {
				this.setState(() => {
					this.state.error.shortTerm = false;
					this.state.error.recommendedMaxRate = false;
					this.state.error.recommendedRate = false;
					this.state.error.validForm = true;
				});
				return;
			}

			if (value && floatMin <= floatValue) {
				this.setState(() => {
					this.state.recommendedMaxRate = parseFloat(value);
					this.state.error.recommendedMaxRate = false;
					this.state.error.shortTerm = false;
					this.state.error.valMoreThanHundred = false;
				});
			} else {
				this.setState(() => {
					this.state.error.recommendedMaxRate = true;
				});
			}

			if (value && value <= 100) {
				this.setState(() => {
					this.state.shortTerm = value;
					this.state.error.valMoreThanHundred = false;
				});
			} else {
				this.setState(() => {
					this.state.error.valMoreThanHundred = true;
				});
			}
			this.checkRecommendedValue(min, recommended, value);
		}

		checkRecommendedValue(min, recommended, max) {
			const floatRecommended = parseFloat(recommended);
			const floatMin = parseFloat(min);
			const floatMax = parseFloat(max);
			if (floatMin <= floatRecommended && floatRecommended <= floatMax) {
				this.setState(() => {
					this.state.error.recommendedRate = false;
				});
			} else {
				this.setState(() => {
					this.state.error.recommendedRate = true;
				});
			}
		}

		updateRecommendedRate(value, min, max) {
			const floatValue = parseFloat(value);
			const floatMin = parseFloat(min);
			const floatMax = parseFloat(max);
			this.setState(() => {
				this.state.touched.recommendedRate = true;
				this.state.error.validForm = false;
			});
			if (value.length == 0) {
				this.setState(() => {
					this.state.error.recommendedRate = false;
					this.state.error.validForm = true;
				});
				return;
			}
			if (value && floatMin <= floatValue && floatValue <= floatMax) {
				this.setState(() => {
					this.state.recommendedRate = floatValue;
					this.state.error.recommendedRate = false;
				});
			} else {
				this.setState(() => {
					this.state.error.recommendedRate = true;
				});
			}
		}

		updateShortTerm(value, max, recommended) {
			const floatValue = parseFloat(value);
			const floatMax = parseFloat(max);
			this.setState(() => {
				this.state.touched.shortTerm = true;
				this.state.touched.valLessThanZero = true;
				this.state.error.validForm = false;
			});
			if (value.length == 0) {
				this.setState(() => {
					this.state.error.shortTerm = false;
					this.state.error.recommendedMaxRate = false;
					this.state.error.validForm = true;
					this.state.error.recommendedRate = false;
				});
				return;
			}
			if (value && floatValue <= floatMax) {
				this.setState(() => {
					this.state.shortTerm = value;
					this.state.error.shortTerm = false;
				});
			} else {
				this.setState(() => {
					this.state.error.shortTerm = true;
				});
			}

			if (value && value >= 0) {
				this.setState(() => {
					this.state.shortTerm = value;
					this.state.error.valLessThanZero = false;
				});
			} else {
				this.setState(() => {
					this.state.error.valLessThanZero = true;
				});
			}
			this.checkRecommendedValue(value, recommended, max);
		}

		deleteClicked(value) {
			toastOnDeleteRecordConfirm().then(async data => {
				if (data && data.value) {
					this.setLoader(true);
					StatesService.delete(value).then(response => {
						if (response.status) {
							const index = this.state.tableData.findIndex(x => x.id == response.data.id);
							this.setState(() => {
								this.state.tableData.splice(index, 1);
								this.removeSelectedRow();
								this.setLoader(false);
							});
						} else {
							this.setLoader(false);
							toastError(response.data);
						}
					});
				}
			});
		}

		editClicked(id) {
			this.resetRowValues();
			this.changeSelectedRow(id);
		}

		saveClicked(data) {
			if (this.isFormValid()) {
				this.setLoader(true);
				let payload = {
					id: data[0],
					recommended_max_rate: data[6],
					recommended_rate: data[5],
					short_term: data[4]
				};
				StatesService.edit(payload).then(response => {
					if (response.status) {
						const index = this.state.tableData.findIndex(x => x.id == response.data.id);
						this.setState(() => {
							this.state.tableData[index] = response.data;
							this.removeSelectedRow();
							this.setLoader(false);
						});
					} else {
						this.setLoader(false);
						toastError(response.data);
					}
				});
			}
		}

		resetRowValues() {
			this.setState({
				recommendedMaxRate: '',
				recommendedRate: '',
				shortTerm: '',
				touched: {
					recommendedMaxRate: false,
					recommendedRate: false,
					shortTerm: false
				},
				error: {
					recommendedMaxRate: false,
					recommendedRate: false,
					shortTerm: false
				}
			});
		}

		cancelEdit() {
			this.removeSelectedRow();
			this.resetRowValues();
		}

		removeSelectedRow() {
			this.setState({ selectedRow: null });
			this.resetRowValues();
		}

		changeSelectedRow(id) {
			this.setState({ selectedRow: id });
			this.resetRowValues();
		}

		isFormValid() {
			return !(
				(this.state.touched.recommendedMaxRate ||
					this.state.touched.recommendedRate ||
					this.state.touched.shortTerm ||
					this.state.touched.valMoreThanHundred ||
					this.state.touched.valLessThanZero) &&
				(this.state.error.recommendedMaxRate ||
					this.state.error.recommendedRate ||
					this.state.error.shortTerm ||
					this.state.error.valMoreThanHundred ||
					this.state.error.valLessThanZero ||
					this.state.error.validForm)
			);
		}

		componentDidMount() {
			this.getAllStateByTenant();
		}

		render() {
			const columns = [
				{
					name: 'id',
					label: 'id',
					options: {
						filter: true,
						sort: true,
						display: false
					}
				},
				{
					name: 'country_id',
					label: 'Country Id',
					options: {
						filter: true
					}
				},
				{
					name: 'short_name',
					label: 'Short Name',
					options: {
						filter: true
					}
				},
				{
					name: 'name',
					label: 'Region Name',
					options: {
						filter: true
					}
				},
				{
					name: 'short_term',
					label: 'Min Interest',
					options: {
						filter: true,
						customBodyRender: (value, tableMeta, updateValue) => (
							<>
								<FormControlLabel
									control={
										<TextField
											value={value || ''}
											type="number"
											InputProps={{
												max: 100,
												min: 0
											}}
											required
											disabled={this.state.selectedRow != tableMeta.rowData[0]}
										/>
									}
									onChange={event => {
										updateValue(event.target.value);
										this.updateShortTerm(
											event.target.value,
											tableMeta.rowData[6],
											tableMeta.rowData[5]
										);
									}}
								/>
								{this.state.error.shortTerm && this.state.selectedRow == tableMeta.rowData[0] && (
									<p className="error">Min Interest Rate should be less than Max Interest Rate.</p>
								)}
								{this.state.error.valLessThanZero && this.state.selectedRow == tableMeta.rowData[0] && (
									<p className="error">Min Interest Rate should either be 0 or more than 0.</p>
								)}
							</>
						)
					}
				},
				{
					name: 'recommended_rate',
					label: 'Recommended Interest',
					options: {
						filter: true,
						customBodyRender: (value, tableMeta, updateValue) => (
							<>
								<FormControlLabel
									control={
										<TextField
											value={value || ''}
											type="number"
											required
											InputProps={{
												max: tableMeta.rowData[4],
												min: tableMeta.rowData[6]
											}}
											disabled={this.state.selectedRow != tableMeta.rowData[0]}
										/>
									}
									onChange={event => {
										updateValue(event.target.value);
										this.updateRecommendedRate(
											event.target.value,
											tableMeta.rowData[4],
											tableMeta.rowData[6]
										);
									}}
								/>
								{this.state.error.recommendedRate && this.state.selectedRow == tableMeta.rowData[0] && (
									<p className="error">
										Recommended Rate should be between Min and Max Interest Rate
									</p>
								)}
							</>
						)
					}
				},
				{
					name: 'recommended_max_rate',
					label: 'Max Interest',
					options: {
						filter: true,
						customBodyRender: (value, tableMeta, updateValue) => (
							<>
								<FormControlLabel
									control={
										<TextField
											value={parseFloat(value)}
											type="number"
											required
											disabled={this.state.selectedRow != tableMeta.rowData[0]}
										/>
									}
									onChange={event => {
										updateValue(event.target.value);
										this.updateRecommendedMaxRate(
											event.target.value,
											tableMeta.rowData[4],
											tableMeta.rowData[5]
										);
									}}
								/>
								{this.state.error.recommendedMaxRate &&
									this.state.selectedRow == tableMeta.rowData[0] && (
										<p className="error">
											Max Interest Rate should be greater than Min Interest Rate
										</p>
									)}
								{this.state.error.valMoreThanHundred &&
									this.state.selectedRow == tableMeta.rowData[0] && (
										<p className="error">Max Interest Rate should be less than 100.</p>
									)}
							</>
						)
					}
				},

				{
					name: 'Actions',
					options: {
						filter: true,
						customBodyRender: (_value, tableMeta, _updateValue) => {
							return (
								<>
									{this.state.selectedRow != tableMeta.rowData[0] ? (
										<>
											<DeleteIcon
												color="secondary"
												onClick={_event => {
													this.deleteClicked(tableMeta.rowData[0]);
												}}
											/>
											<EditIcon
												color="primary"
												onClick={_event => {
													this.editClicked(tableMeta.rowData[0]);
												}}
											/>
										</>
									) : (
										<>
											<SaveIcon
												style={{ color: green[500] }}
												disabled={this.isFormValid()}
												onClick={_event => {
													this.saveClicked(tableMeta.rowData);
												}}
											/>
											<CancelIcon
												style={{ color: orange[500] }}
												onClick={_event => {
													this.cancelEdit();
												}}
											/>
										</>
									)}
								</>
							);
						}
					}
				}
			];

			const options = {
				serverSide: false,
				print: false,
				download: false,
				filter: false,

				selectableRows: 'none',
				textLabels: {
					body: {
						noMatch: this.state._setLoader ? (
							<Spin size="large" indicator={<LoadingOutlined />}>
								{' '}
								Loading data please wait...
							</Spin>
						) : (
							'Sorry, no matching records found'
						)
					}
				},
				responsive: 'scroll'
			};
			return (
				<>
					<PageHeader text="Regions">
						<div className="col-sm-6">
							<span style={{ marginLeft: '70%' }}>
								{' '}
								<Link to={`/admin/tenant/state/create/${this.props.match.params.id}`}>Add Region</Link>
							</span>
						</div>
					</PageHeader>
					<MuiThemeProvider theme={this.getMuiTheme()}>
						<MUIDataTable
							columns={columns}
							data={this.state.tableData}
							options={options}
							theme={this.getMuiTheme()}
						/>
					</MuiThemeProvider>
					{this.state._isLoading ? <Loader /> : null}
				</>
			);
		}
	}
);
